/* tslint:disable */
/* eslint-disable */
export enum ManualType {
    GDPR = 1,
    GeneralEmployeeInformation = 2
}